export default __webpack_public_path__ + "13bec6c11abe1fc9c41027adeeea39a4.svg";